/**
 * Auth gate for any subtree that requires a signed-in user. Lives inside
 * the auth feature because it reads the auth store; the router (in
 * `src/app/`) imports it from here.
 */
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { paths } from '@/config/paths';

import { useAuth } from '../hooks/use-auth';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`${paths.home}?next=${encodeURIComponent(next)}`} replace />;
  }

  return <>{children}</>;
}
